import moment from 'moment'

export const isRefundPending = payment =>
  payment?.refundProcessorStatus === 'Pending' && !payment?.hasRefund

export const REFUND_WINDOW_CLOSED_MESSAGE =
  'Refund is only allowed within 3 months of the cleared date.'

export const CHARGEBACK_WINDOW_CLOSED_MESSAGE =
  'Chargeback is only allowed within 1 year of the cleared date.'

export const isWithinRefundWindow = (paymentClearedOn, today = moment()) => {
  if (!paymentClearedOn) {
    return false
  }

  const deadline = moment(paymentClearedOn).startOf('day').add(3, 'months')
  return !moment(today).startOf('day').isAfter(deadline)
}

export const isWithinChargebackWindow = (paymentClearedOn, today = moment()) => {
  if (!paymentClearedOn) {
    return false
  }

  const deadline = moment(paymentClearedOn).startOf('day').add(1, 'year')
  return !moment(today).startOf('day').isAfter(deadline)
}

const canManageClearedPayment = (payment, canManagePaymentStatuses) =>
  Boolean(
    canManagePaymentStatuses &&
      payment?.processorStatus === 'Success' &&
      !payment?.hasChargeback &&
      !payment?.hasRefund &&
      !isRefundPending(payment)
  )

export const canRecordRefund = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses) &&
  payment?.paymentProcessedBy === 'Nuvei' &&
  isWithinRefundWindow(payment?.paymentClearedOn)

export const canDoRefund = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses) &&
  payment?.paymentProcessedBy === 'Nuvei' &&
  isWithinRefundWindow(payment?.paymentClearedOn)

export const canAddChargeback = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses) &&
  isWithinChargebackWindow(payment?.paymentClearedOn)

export const getRefundWindowClosedReason = (payment, canManagePaymentStatuses) => {
  if (
    !canManageClearedPayment(payment, canManagePaymentStatuses) ||
    payment?.paymentProcessedBy !== 'Nuvei' ||
    isWithinRefundWindow(payment?.paymentClearedOn)
  ) {
    return null
  }

  return REFUND_WINDOW_CLOSED_MESSAGE
}

export const getChargebackWindowClosedReason = (payment, canManagePaymentStatuses) => {
  if (
    !canManageClearedPayment(payment, canManagePaymentStatuses) ||
    isWithinChargebackWindow(payment?.paymentClearedOn)
  ) {
    return null
  }

  return CHARGEBACK_WINDOW_CLOSED_MESSAGE
}
